export default __webpack_public_path__ + "296b9595b350f0a3aab63eb7adb54b0e.png";